import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '@app/utility/util.service'

@Pipe({
  name: 'thaidate'
})
export class ThaiDatePipe implements PipeTransform {
  constructor(
    private util: UtilService
  ){

  }
  transform(date: string, format: string): string {
    return this.util.transformDate(date, format)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/thaidate.pipe.ts